export default __webpack_public_path__ + "static/media/heart.085d3d2c.svg";